import React from 'react';
import { Button } from '../ui/button';
import { AlertCircle, ArrowRight } from 'lucide-react';

const ProblemSolutionSection = ({ data, onCtaClick }) => {
  const problems = [
    "Resident complaints about dirty communal areas",
    "Missed or inconsistent cleans",
    "Chasing cleaners who don't turn up",
    "Standards slipping over time"
  ];

  return (
    <section className="px-5 sm:px-6 py-14 md:py-20 bg-[#f9fafb]">
      <div className="max-w-3xl mx-auto">
        {/* Transition Line */}
        <p className="text-gray-600 text-base sm:text-lg mb-6 leading-relaxed">
          Most managing agents contact us after dealing with one or more of the following:
        </p>
        
        {/* Problems */}
        <div className="mb-6">
          <ul className="space-y-3 sm:space-y-4">
            {problems.map((problem, index) => (
              <li key={index} className="flex items-start gap-3">
                <AlertCircle className="w-5 h-5 text-amber-500 flex-shrink-0 mt-0.5" strokeWidth={1.5} />
                <span className="text-gray-700 text-base sm:text-lg leading-relaxed">{problem}</span>
              </li>
            ))}
          </ul>
        </div>
        
        {/* Emotional Impact Line */}
        <p className="text-gray-500 mb-10 italic text-sm sm:text-base">
          These issues damage resident satisfaction and waste management time.
        </p>
        
        {/* Solution Card */}
        <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-[0_1px_3px_rgba(0,0,0,0.06),0_1px_2px_rgba(0,0,0,0.04)] border border-gray-100/80">
          <p className="text-lg sm:text-xl md:text-2xl text-gray-900 font-semibold text-center leading-relaxed">
            We provide dependable, scheduled communal block cleaning — done properly, every time.
          </p>
          <p className="text-center text-gray-500 text-sm mt-4 leading-relaxed">
            Designed for managing agents who need consistency, not constant follow-ups.
          </p>
        </div>
        
        {/* CTA */}
        <div className="text-center mt-10">
          <Button
            onClick={onCtaClick}
            size="lg"
            data-testid="problem-section-cta-btn"
            className="bg-[#00c853] hover:bg-[#00a844] text-white px-6 sm:px-8 py-4 text-base sm:text-lg font-medium rounded-xl transition-all duration-200 h-auto min-h-[48px] sm:min-h-[56px] shadow-[0_2px_8px_rgba(0,200,83,0.25)] hover:shadow-[0_4px_12px_rgba(0,200,83,0.35)] hover:-translate-y-0.5 active:translate-y-0"
          >
            Get a Free Site Assessment
            <ArrowRight className="ml-2 w-5 h-5" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolutionSection;
